import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const whiteList = ['/login', '/authredirect'];// 不重定向白名单

function hasPermission(roles, permissionRoles) {
    // admin权限 直接通过
    if (roles.indexOf('admin') >= 0) {
        return true;
    }
    if (!permissionRoles) {
        return true;
    }
    return roles.some(role => permissionRoles.indexOf(role) >= 0);
}

router.beforeEach((to, from, next) => {
    NProgress.start();
    let hasLogin = store.getters.token ? true : false;
    if (!hasLogin) {
        let ul = localStorage.getItem('ul') ? JSON.parse(localStorage.getItem('ul')) : '';
        if (ul && new Date().getTime() - ul.time < 1000 * 60 * 60 * 24 * 3) {
            hasLogin = true;
        }
    }
    if (hasLogin) {
        if (to.path === '/login') {
            next({path: '/'})
        } else {
            if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
                store.dispatch('GetInfo').then(res => { // 拉取user_info
                    // const roles = res.data.data.roles;
                    const functions = res.data.data.functions;
                    store.dispatch('GenerateRoutes', {functions}).then(() => {
                        router.addRoutes(store.getters.addRouters);
                        next({...to}); // hack方法 确保addRoutes已完成
                    })
                }).catch(() => {
                    store.dispatch('FedLogOut').then(() => {
                        next({path: '/login'})
                    }).catch(()=>{
                        next({path: '/login'})
                    })
                });
            }
            else {
                store.dispatch('getNowRoutes', to);
                if (hasPermission(store.getters.roles, to.meta.role)) {
                    next();
                } else {
                    next({path: '/', query: {noGoBack: true}})
                }
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next();
        } else {
            next('/login');
            NProgress.done(); // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
        }
    }
});

router.afterEach(() => {
    NProgress.done(); // 结束Progress
});



// WEBPACK FOOTER //
// ./src/login.js